module.exports = __webpack_public_path__ + "static/media/no-reviews-illustration.53b937a2.svg";